import { InfiniteList, useGetIdentity, useRefresh } from "react-admin"
import InvoiceFilters from "./InvoiceFilters"
import ListResults from "./list/ListResults"
import { InvoiceReadModel, ReverseInvoiceReadModel } from "../GeneratedClients/FreeBillApi"
import { useEffect, useState } from "react"
import InvoiceListActions from "./InvoiceListActions"
import updateInvoiceState from "./list/updateInvoiceState"
import { HubConnection } from "@microsoft/signalr"
import InvoiceDatagrid from "./InvoiceDatagrid"

interface IProps {
  connections?: {invoiceHub?: HubConnection, reverseInvoiceHub?: HubConnection}
}

const InvoiceList = ({connections}: IProps) => {
  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  const refresh = useRefresh()
  const [record, setRecord] = useState<InvoiceReadModel | ReverseInvoiceReadModel>()

  useEffect(() => {
    updateInvoiceState(identity?.id.toString())
  }, [])

  useEffect(() => {
    refresh()
  }, [record])

  connections?.invoiceHub?.on('InvoiceUpdated', (invoice) => {
    setRecord(invoice)
  })

  connections?.reverseInvoiceHub?.on('ReverseInvoiceUpdated', (reverseInvoice) => {
    setRecord(reverseInvoice)
  })

  if(identityLoading) return null

  return (
    <InfiniteList filters={InvoiceFilters} actions={<InvoiceListActions />} sort={{field: "createdAt", order: "DESC"}} >
      <ListResults resource="invoices" />
      <InvoiceDatagrid userId={identity?.id.toString()!} />
    </InfiniteList>
  )
}

export default InvoiceList